/// <reference types="@angular/localize" />
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { importProvidersFrom, isDevMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideServiceWorker } from '@angular/service-worker';
import { SocketIoConfig, SocketIoModule } from 'ngx-socket-io';
import { provideToastr } from 'ngx-toastr';
import { AuthInterceptor } from './app/_auth/auth.interceptor';
import { PayloadEncryptionInterceptor } from './app/_auth/payload-encryption.interceptor';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

export const socketConfig: SocketIoConfig = {
  url: 'https://sensor.auton.in/',
  options: {},
}; // production

// export const socketConfig: SocketIoConfig = {
//   url: environment.SOCKET_URL,
//   options: {}
// };

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js')
    .then((registration) => {
      // console.log('Firebase messaging Service Worker registered:', registration);
    })
    .catch((error) => {
      // console.error('Firebase messaging SW registration failed:', error);
    });
}

bootstrapApplication(AppComponent, {
  providers: [
    ...appConfig.providers,

    // ✅ THIS IS MANDATORY
    provideHttpClient(withInterceptorsFromDi()),

    // ✅ REGISTER INTERCEPTOR HERE
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },

    // Registered AFTER AuthInterceptor on purpose. Interceptors nest in
    // registration order, so this one sits closest to the network: it seals the
    // body last and unseals the response first, which means AuthInterceptor's
    // 401 handling still inspects ordinary plaintext responses and needs no
    // knowledge of encryption. Controlled by environment.encryption.enabled.
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PayloadEncryptionInterceptor,
      multi: true,
    },

    importProvidersFrom(SocketIoModule.forRoot(socketConfig)),

    provideToastr({
      positionClass: 'toast-top-right',
      timeOut: 4000,
      progressBar: false,
      closeButton: true,
      easing: 'ease-in-out',
      progressAnimation: 'decreasing',
      tapToDismiss: true,
      enableHtml: true,
    }),

    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
}).catch((err) => console.error(err));
